// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"EmailAFriend_modalContainer__NB361"};